module.exports = __webpack_public_path__ + "img/ES2100.24c5c5db.svg";